import type { IrrDataPoint } from "./types";

export function getIrrValue(
  p: { irr: number; irr_sofr_adjusted?: number },
  sofrAdjusted: boolean
): number {
  return sofrAdjusted && p.irr_sofr_adjusted !== undefined ? p.irr_sofr_adjusted : p.irr;
}

export function getDataForDate(
  date: string,
  excludedRoots: string[],
  irrData: IrrDataPoint[],
  roots: string[],
  sofrAdjusted: boolean
) {
  const filteredRoots = roots.filter((r) => !excludedRoots.includes(r));
  const filteredIrrData = irrData.filter((d) => !excludedRoots.includes(d.root));
  const yValues = filteredIrrData.map((d) => {
    const point = d.data.find((p) => p.date === date);
    return point ? getIrrValue(point, sofrAdjusted) : 0;
  });
  return [
    {
      x: filteredRoots,
      y: yValues,
      text: yValues.map((v) => (v * 100).toFixed(3) + "%"),
      textposition: "outside" as const,
      type: "bar" as const,
      name: date,
    },
  ];
}

/** Roots that have at least one date where IRR falls outside [minIrr, maxIrr]. */
export function getRootsExceedingRange(
  irrData: IrrDataPoint[],
  minIrr: number,
  maxIrr: number,
  excludedRoots: string[],
  sofrAdjusted: boolean
): string[] {
  return irrData
    .filter((d) => !excludedRoots.includes(d.root))
    .filter((d) =>
      d.data.some((p) => {
        const irr = getIrrValue(p, sofrAdjusted);
        return irr < minIrr || irr > maxIrr;
      })
    )
    .map((d) => d.root);
}
